<template>
  <div class="c-input u-w456">
    <div class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action no-margin">
      <div class="c-input u-w230 no-margin">
        <datepicker
          ref="refclickDate"
          v-model="clickDate"
          :name="'click_date' + inputName"
          format="yyyy/MM/dd"
          placeholder="YYYY/MM/DD"
          input-class="c-input__item c-input__item--overlay-ico"
          calendar-class="datepicker_calendar"
          :language="ja"
          @input="onclickDateInput"
        />
        <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('click_date')">
          <div class="c-icon c-icon--white u-wh22">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#calendar" />
            </svg>
          </div>
        </div>
        <div class="c-error c-error--balloon c-error--date">
          <div class="c-error__text"></div>
        </div>
      </div>
      <div class="c-select-time u-w200">
        <timepicker
          ref="timeSelect"
          v-model="clickTime"
          format="HH:mm"
          hour-label="時"
          minute-label="分"
          :name="'time_select' + inputName"
          placeholder="時間設定"
          advanced-keyboard
          manual-input
          auto-scroll
          :model-value="clickTime"
          @change="onclickTimeChange"
        />
        <div class="c-error c-error--balloon c-error--time">
          <div class="c-error__text"></div>
        </div>
      </div>
    </div>

    <div class="c-error c-error--balloon">
      <div class="c-error__text"></div>
    </div>
  </div>
</template>

    <script>
import Datepicker from './Datepicker.vue';
const ja = 'ja';
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'
import moment from 'moment';

export default {
  components: {
    'datepicker': Datepicker,
    'timepicker': VueTimepicker,
  },
  props: {
    value: String,
    inputName: {
      type: String,
      default: 'click_condition',
    },
    isError: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
  },
  emits: ['change'],
  data() {
    return {
      currentValue: this.value,
      clickDate: null,
      clickTime: null,
      ja: ja,
    }
  },
  watch: {
    value: function (newValue, _oldValue) {
      this.setCurrentValue(newValue);
    }
  },
  mounted: function () {
    this.setCurrentValue(this.currentValue);
  },
  methods: {
    setCurrentValue: function (newValue) {
      this.currentValue = newValue;
      if (this.currentValue) {
        if (this.currentValue.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$/)) {
          let unixTime = Date.parse(this.currentValue);
          let date = new Date(unixTime);
          if (date) {
            this.clickDate = date;
            let hourString = '' + date.getHours();
            let minuteString = '' + date.getMinutes();
            this.clickTime = hourString.padStart(2, '0') + ':' + minuteString.padStart(2, '0');
          }
        }
      }
    },
    onclickDateInput: function () {
      this.onValueChange();
    },
    onclickTimeChange: function () {
      this.onValueChange();
    },
    onValueChange: function () {
      let value = null;
      // 日時
      if (this.clickDate && this.clickTime) {
        let timeString = '';
        if (typeof (this.clickTime) == 'string') {
          timeString = this.clickTime;
        } else if (typeof (this.clickTime) == 'object' && this.clickTime.HH) {
          if (!this.clickTime.mm) {
            this.clickTime.mm = '00'
          }
          timeString = `${this.clickTime.HH}:${this.clickTime.mm}`
        }

        value = moment(this.clickDate).format('YYYY-MM-DD') + ' ' + timeString + ':00';
      }
      this.currentValue = value;
      this.$emit("change", this.currentValue);
    },
    showCalendar: function (_name) {
      this.$refs.refclickDate.$el.querySelector('input').focus();
      this.$refs.refclickDate.showCalendar();
    },

  },
}
    </script>

